import { T, useTheme, Ico, Card, Btn } from '../../../design';
import type { IconName } from '../../../design';

export function Skeletons({ n = 3 }: { n?: number }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {Array.from({ length: n }).map((_, i) => (
        <div key={i} style={{ height: 132, borderRadius: 16, background: `linear-gradient(90deg,${T.tertiary} 25%, ${T.surface} 50%, ${T.tertiary} 75%)`, backgroundSize: '300% 100%', animation: 'pp-shimmer 1.3s linear infinite' }} />
      ))}
    </div>
  );
}

export function ErrorState({ onRetry, message }: { onRetry: () => void; message?: string }) {
  return (
    <Card pad={28} style={{ textAlign: 'center', marginTop: 8 }}>
      <div style={{ width: 56, height: 56, borderRadius: 16, background: T.errorBg, color: T.error, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}><Ico.alert size={26} /></div>
      <div style={{ fontSize: 16, fontWeight: 800, color: T.fg }}>Kunne ikke hente kurser</div>
      <div style={{ fontSize: 13, color: T.fg3, marginTop: 6, lineHeight: 1.5 }}>{message || 'Der opstod en fejl. Tjek forbindelsen og prøv igen.'}</div>
      <Btn variant="secondary" size="md" onClick={onRetry} style={{ marginTop: 16 }}>Prøv igen</Btn>
    </Card>
  );
}

export function EmptyState({ icon = 'book', title, sub }: { icon?: IconName; title: string; sub?: string }) {
  const t = useTheme();
  const Ic = Ico[icon];
  return (
    <Card pad={28} style={{ textAlign: 'center', marginTop: 8 }}>
      <div style={{ width: 56, height: 56, borderRadius: 16, background: T.accentLight, color: t.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}><Ic size={26} /></div>
      <div style={{ fontSize: 16, fontWeight: 800, color: T.fg }}>{title}</div>
      {sub && <div style={{ fontSize: 13, color: T.fg3, marginTop: 6, lineHeight: 1.5 }}>{sub}</div>}
    </Card>
  );
}
